import { BaseSanitizer } from './BaseSanitizer';
export class GovernmentIdSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'GOVERNMENT_ID', 'governmentIds', enabled);
    }
    detectMatches(text) {
        const patterns = [
            this.dniPattern(),
            this.niePattern(),
            this.tinEinPattern(),
            this.passportPattern()
        ];
        const matches = [];
        for (const pattern of patterns) {
            pattern.lastIndex = 0;
            let match;
            while ((match = pattern.exec(text)) !== null) {
                matches.push({
                    originalText: match[0],
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + match[0].length
                });
            }
        }
        return matches;
    }
    dniPattern() {
        return /(?:(?<!\d)\d{8}[TRWAGMYFPDXBNJZSQVHLCKE](?!\d))(?!\w)/gi;
    }
    niePattern() {
        return /(?:(?<!\w)[XYZ]\d{7}[TRWAGMYFPDXBNJZSQVHLCKE](?!\d))(?!\w)/gi;
    }
    tinEinPattern() {
        return /(?:EIN|TIN|Employer Identification Number|Taxpayer Identification Number)[:\s]+(?!00|0{3})\d{2}[- ]?\d{7}\b/gi;
    }
    passportPattern() {
        // Passport pattern now REQUIRES a keyword prefix to reduce false positives
        // Matches formats like "passport: AB123456789" or "passport number AB123456"
        return /(?:passport(?:\s+(?:number|no|num|#|id))?[:\s]+)([A-Za-z]{1,2}[0-9]{6,9})\b(?!\d)/gi;
    }
}
